import { Routes, Route } from 'react-router-dom';
import NewsRoom from '../pages/NewsRoom';
import PressDetail from '../pages/PressDetail';
import PressRoom from '../pages/PressRoom';
import StoriesRoom from '../pages/StoriesRoom';
import NewsLetter from '../pages/NewsLetter';
import InvestorRoom from '../pages/InvestorRoom'
import InvestorDetail from '../pages/InvestorDetail'


function App() {
  return (
    <Routes>
      <Route path="/" element={<NewsRoom />} />
      <Route path="/newsroom" element={<NewsRoom />} />
      <Route path="/pressroom" element={<PressRoom />} />
      <Route path="/pressdetail/:dt/*" element={<PressDetail />} />
      <Route path="/storiesroom" element={<StoriesRoom />} />
      <Route path="/newsletter" element={<NewsLetter />} />
      <Route path="/investorroom" element={<InvestorRoom />} />
      <Route path="/investordetail/:dt/*" element={<InvestorDetail />} />
    </Routes>
  );
}

export default App;
